import { Button, Heading, Markdown } from '@altify/components';
import { useContent } from '@altify/utils';
import CryptoDepositsUnavailableImage from 'app/_authenticated/products/explore/assets/RebalanceIcon.svg';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { createCallable } from 'react-call';
import { View } from 'react-native';
import { useGetFeatureFlagsQuery } from 'store/slices/feature-flags-api';
import { content } from './CryptoDepositsUnavailableModal.content';

export const CRYPTO_DEPOSIT_FEATURE_FLAG_CODE = 'CRYPTODEP';

const CryptoDepositsUnavailableModal = ({
  isOpen,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: () => void;
}) => {
  const { data: featureFlags } = useGetFeatureFlagsQuery();
  const featureFlag = featureFlags?.find(
    flag => flag.code === CRYPTO_DEPOSIT_FEATURE_FLAG_CODE,
  );
  const displayMessage =
    featureFlag?.displayMessage?.replace(/\\n/g, '\n') || '';

  const localizedContent = useContent(content);

  return (
    <DialogOrBottomSheet
      blurEnabled={true}
      isOpen={isOpen}
      onClose={handleClose}
      backgroundColor="#0C1C2C"
      footerContent={
        <View className="flex flex-col gap-4 px-4 my-4">
          <Button
            onPress={() => {
              handleClose();
            }}
            text={localizedContent.gotIt}
            className="w-full"
          />
        </View>
      }>
      <View className="w-full flex flex-col items-center gap-4 py-4 px-8 gap-6">
        <img src={CryptoDepositsUnavailableImage} alt="" />
        <Heading level={4} className="text-center">
          {featureFlag?.name}
        </Heading>
        <Markdown
          textColor="white"
          styles={{
            text: {
              textAlign: 'center',
              color: '#ffffff',
              display: 'flex',
              fontFamily: 'Bozon',
              justifyContent: 'center',
              lineHeight: 25,
              fontWeight: 300,
            },
            paragraph: {
              color: '#ffffff',
              justifyContent: 'center',
              fontFamily: 'Bozon',
              lineHeight: 25,
              fontWeight: 300,
            },
          }}>
          {displayMessage}
        </Markdown>
      </View>
    </DialogOrBottomSheet>
  );
};

export default CryptoDepositsUnavailableModal;

/**
 * Called imperatively from every crypto deposit entry point via
 * `useCryptoDepositGuard()`, so the six call sites don't each carry their own
 * open state and mount. Mounted once in `CallableRoot`.
 */
export const CryptoDepositsUnavailableModalCallable = createCallable<
  void,
  boolean
>(({ call }) => (
  <CryptoDepositsUnavailableModal isOpen handleClose={() => call.end(true)} />
));
